import PageContainer from "@/components/layout/page-container";
import { AddOpportunityForm } from "@/modules/opportunities/add-opportunities-form";

const AddOpportunities = () => {
  return (
    <PageContainer scrollable={true}>
      <div className="max-w-4xl rounded bg-white p-6">
        <div className="space-y-6">
          <AddOpportunityForm />
        </div>
      </div>
    </PageContainer>
  );
};

export default AddOpportunities;
